import { IconButton, TableCell, TableRow } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { TableData } from '../types';
import s from '../styles.module.scss';
import { Dispatch, SetStateAction } from 'react';
import getNumberOfDaysBetweenNowAndFutureDate from '../../../utils/get-days-between-now-and-future-date';

type Props = {
  data: TableData;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setId: Dispatch<SetStateAction<string>>;
};

const Row = ({ data, setIsOpen, setId }: Props) => {
  const handleClick = (id: string) => {
    setIsOpen(true);
    setId(id);
  };

  const daysTillReset = getNumberOfDaysBetweenNowAndFutureDate(data.resetCallsDate);

  return (
    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={s.row}>
      <TableCell>{data.customer}</TableCell>
      <TableCell>{data.zipCode}</TableCell>
      <TableCell>{data.numberOfPlayers}</TableCell>
      <TableCell>{data.callsExpected}</TableCell>
      <TableCell>{data.callsActual}</TableCell>
      <TableCell>
        {daysTillReset} {daysTillReset === 1 ? 'Day' : 'Days'}
      </TableCell>
      {/* <td> wraps icon so don't get invalid DOM nesting error*/}
      <td className={s.delete} onClick={() => handleClick(data.id)}>
        <IconButton>
          <DeleteIcon />
        </IconButton>
      </td>
    </TableRow>
  );
};

export default Row;
